export default __webpack_public_path__ + "static/media/rapid.3340ff26.jpg";